import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';
import GetReceipt from '../components/GetReceipt';

const BookingDetails = () => {
    const { bookingId, categoryId } = useParams();
    const [bookingData, setBookingData] = useState([]);
    const [filteredBooking, setFilteredBooking] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [popupUrl, setPopupUrl] = useState(null);
    const [guestId, setGuestId] = useState('');
    const navigate = useNavigate();

    const openPopup = (url) => {
        setPopupUrl(url);
    };

    const closePopup = () => {
        setPopupUrl(null);
    };
    
    useEffect(() => {
        const fetchBookingDetails = async () => {
            setLoading(true);
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);
            formData.append('category', categoryId);
    
            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.getMyBooking}`,
                    data: formData
                });
    
                if (response.data && response.data.items.length > 0) {
                    setBookingData(response.data.items);
                    const booking = response.data.items.find(
                        (item) => item.stay_booking_id === Number(bookingId)
                    );
                    setFilteredBooking(booking || null);
                    setGuestId(booking.customer_id);
                } else {
                    setError('No booking data found for this category.');
                }
            } catch (err) {
                setError('An error occurred while fetching booking data.');
            } finally {
                setLoading(false);
            }
        };

        fetchBookingDetails();
    }, [categoryId, bookingId]);

    const handleGuestProfile = () => {
        navigate(`/guest-details/${bookingId}/${categoryId}`);
    }

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>No booking found for the provided ID.</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Booking Details</title>
                <meta name="description" content="" />
            </Helmet>

            <div className='booking-detail-section'>
                {filteredBooking && (
                    <>
                        <h4 className='bd-title'>{filteredBooking.listing_title}, {filteredBooking.city_town}</h4>
                        <div className='category-img-section'>
                            <div className='ciso'>
                                <img src={filteredBooking.cover_photo} alt='' className='img-fluid' />
                            </div>
                            <div className='cist'>
                                <img style={{height:'170px'}} src={filteredBooking.category_image_url} alt='' className='img-fluid w-100' />
                            </div>
                        </div>

                        <div class="check-container">
                            <div class="check-card cc-checkIn">
                                <p><img src={'/assets/img/icons/ws_checkin_checkout_icon_3.svg'} alt='' className='img-fluid cc-img' /> <strong>CHECK-IN</strong></p>
                                <p className='ccdbox'><img src={'/assets/img/icons/ws_date_time_icon.svg'} alt='' className='img-fluid cc-img' /> {filteredBooking.formatted_checkin_date}</p>
                                <p className='ccdbox'><img src={'/assets/img/icons/ws_date_time_icon.svg'} alt='' className='img-fluid cc-img' /> {filteredBooking.formatted_checkin_time}</p>
                            </div>

                            <div class="divider"></div>

                            <div class="check-card cc-checkOut">
                                <p><strong>CHECK-OUT</strong> <img src={'/assets/img/icons/ws_checkin_checkout_icon_3.svg'} alt='' className='img-fluid cc-img' /></p>
                                <p className='ccdbox'>{filteredBooking.formatted_checkout_date} <img src={'/assets/img/icons/ws_date_time_icon.svg'} alt='' className='img-fluid cc-img' /></p>
                                <p className='ccdbox'>{filteredBooking.formatted_checkout_time} <img src={'/assets/img/icons/ws_date_time_icon.svg'} alt='' className='img-fluid cc-img' /></p>
                            </div>
                        </div>

                        <span className='b-line'></span>

                        <div>
                            <h4 className='bd-title'>Reservation Details</h4>
                            <div className='bd-box'>
                                <strong>Guest info</strong>
                                <div className='bd-sub-box' onClick={() => handleGuestProfile()} style={{justifyContent:'space-between', cursor:'pointer'}}>
                                    <div className='bd-ssb-box'>
                                        <img src={'/assets/img/icons/profile_icon.gif'} alt="" className="bd-icon" />
                                        <p>{filteredBooking.customer_name}</p>
                                    </div>
                                    <div>
                                        <i class="fas fa-chevron-right"></i>
                                    </div>
                                </div>
                                <div className='bd-sub-box'>
                                    <img src={'/assets/img/icons/pointer_icon.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.customer_phone}</p>
                                </div>
                            </div>
                            <hr></hr>
                            {filteredBooking.checkin_guest_name && filteredBooking.checkin_guest_name.length > 0 && (
                            <>
                                <div className="bd-box">
                                    <strong>Check-in User Details</strong>
                                    {filteredBooking.checkin_guest_name.map((guest, index) => (
                                        <div key={index} className="bd-sub-box" style={{justifyContent:'space-between'}}>
                                            <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                                                <img
                                                    src="/assets/img/icons/pointer_icon.svg"
                                                    alt=""
                                                    className="bd-icon"
                                                />
                                                <p>{guest.guest_name}</p>
                                            </div>
                                            <div className='gipds'>
                                                {guest.identity_proof ? (
                                                    <a href={guest.identity_proof} target="_blank" rel="noopener noreferrer">
                                                        View Doc
                                                    </a>
                                                ) : (
                                                    <span>No Doc</span>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                    {filteredBooking.actual_checkin_datetime && (
                                    <div className='bd-sub-box'>
                                        <img src={'/assets/img/icons/pointer_icon.svg'} alt="" className="bd-icon" />
                                        <div>
                                            <span>CHECKIN TIME - </span><span>{filteredBooking.actual_checkin_datetime}</span>
                                        </div>
                                    </div>
                                    )}
                                    {filteredBooking.actual_checkout_datetime && (
                                    <div className='bd-sub-box'>
                                        <img src={'/assets/img/icons/pointer_icon.svg'} alt="" className="bd-icon" />
                                        <div>
                                            <span>CHECKOUT TIME - </span><span>{filteredBooking.actual_checkout_datetime}</span>
                                        </div>
                                    </div>
                                    )}
                                </div>
                                <hr />
                            </>
                            )}
                            <div className='bd-box'>
                                <strong>Confrimation code</strong>
                                <div className='bd-sub-box'>
                                    <img src={'/assets/img/icons/pointer_icon.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.confirmation_code}</p>
                                </div>
                            </div>
                            {/*<hr></hr>
                            <div className='doc-box' onClick={() => openPopup(filteredBooking.stay_booking_receipt_url)}>
                                <div>
                                    <span>Get receipt</span>
                                </div>
                                <div>
                                    <i class="fas fa-chevron-right"></i>
                                </div>
                            </div>*/}
                        </div>

                        <span className='b-line'></span>

                        <div>
                            <h4 className='bd-title'>Payment info</h4>
                            <div className='bd-box'>
                                <strong>Amount paid</strong>
                                <div className='bd-sub-box'>
                                    <img src={'/assets/img/icons/calendar_rupee.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.priceItem.total}</p>
                                </div>
                            </div>
                            <hr></hr>
                            <div className='doc-box' onClick={() => openPopup(filteredBooking.stay_booking_payment_receipt_url)}>
                                <div>
                                    <span>Get receipt</span>
                                </div>
                                <div>
                                    <i class="fas fa-chevron-right"></i>
                                </div>
                            </div>
                        </div>

                        <span className='b-line'></span>

                        <div>
                            <h4 className='bd-title'>Cancellation policy</h4>
                            <p> This reservation is non-refundable.</p>
                        </div>
                    </>
                )}
            </div>

            <GetReceipt url={popupUrl} onClose={closePopup} />

        </div>
    );
};

export default BookingDetails;
